// Auto generated file, do not manually modify!
// com.hotpads.customermanagement.client.listingspotlight.enums.PlacementSource

export enum PlacementSource {
  AUTO = 'AUTO',
  EXCLUDED = 'EXCLUDED',
  PINNED = 'PINNED',
}

export const PlacementSource_values = [PlacementSource.AUTO, PlacementSource.EXCLUDED, PlacementSource.PINNED] as const;
